import { render, staticRenderFns } from "./PortfolioPhase.vue?vue&type=template&id=322fbc59&"
import script from "./PortfolioPhase.vue?vue&type=script&lang=js&"
export * from "./PortfolioPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports